/** @flow */

export default function(t: (name: string) => string) {
  return {
    "ui:order": [
      "markEmailsAsPrivate",
      "supressAllEmailContent",
      "allowHyperlinksInInstructions",
      "*",
    ],
    markEmailsAsPrivate: {
      "ui:widget": "switch-button",
      "ui:options": {
        label: t("EMAIL_PRIVACY"),
        description: t("EMAIL_PRIVACY_DESCRIPTION"),
      },
    },
    supressAllEmailContent: {
      "ui:widget": "switch-button",
      "ui:options": {
        label: t("EMAIL_SUPPRESSION"),
        description: t("EMAIL_SUPPRESSION_DESCRIPTION"),
      },
    },
    allowHyperlinksInInstructions: {
      "ui:widget": "switch-button",
      "ui:options": {
        label: t("EMAIL_HYPERLINKS"),
        description: t("EMAIL_HYPERLINKS_DESCRIPTION"),
      },
    },
  };
}
